// src/views/source-connections/components/wizard/forms/ServiceAccountForm.jsx

import React, { useState, useRef } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import Input from "../../../../../components/form-components/Input";

registerPlugin(FilePondPluginFileValidateType);

const ServiceAccountForm = ({ sourceType, formData, onChange }) => {
  const filePondRef = useRef(null);
  const [fileError, setFileError] = useState("");

  const handleFieldChange = (name, value) => {
    onChange({ ...formData, [name]: value });
  };

  const handleFileUpdate = (fileItems) => {
    setFileError("");
    if (fileItems.length === 0) {
      onChange({ ...formData, file: null, fileContent: null });
      return;
    }
    const file = fileItems[0].file;
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        JSON.parse(e.target.result);
        onChange({ ...formData, file, fileContent: e.target.result });
      } catch {
        setFileError("Invalid JSON file. Please upload a valid service account key.");
        filePondRef.current?.removeFiles();
      }
    };
    reader.readAsText(file);
  };

  return (
    <div>
      {sourceType.fields.map((field) => (
        <div key={field.name} className="mb-5">
          <Input
            title={
              <>
                {field.label}
                {!field.required && <span className="text-text-2 font-normal ml-1">(optional)</span>}
              </>
            }
            name={field.name}
            type="text"
            value={formData[field.name] || ""}
            onChange={(e) => handleFieldChange(field.name, e.target.value)}
            placeholder={field.placeholder}
          />
        </div>
      ))}

      <div className="mb-5">
        <label className="block text-sm font-medium text-text-2 mb-2">Service Account Key (JSON)</label>
        <FilePond
          ref={filePondRef}
          allowMultiple={false}
          maxFiles={1}
          credits={false}
          instantUpload={false}
          acceptedFileTypes={["application/json"]}
          onupdatefiles={handleFileUpdate}
          labelIdle='<span class="text-sm text-text-2">Drop your JSON key file here or <span class="filepond--label-action">browse</span></span>'
        />
        {fileError && <p className="text-xs text-danger mt-1">{fileError}</p>}
      </div>

      <div className="flex items-start gap-2.5 p-3 bg-surface-2 border border-border rounded-ctrl text-xs text-text-2">
        <span className="text-primary mt-0.5">🔒</span>
        <span>Key file contents are transmitted over HTTPS/TLS and encrypted at rest on the server.</span>
      </div>
    </div>
  );
};

export default ServiceAccountForm;
